import api from "@/services/api";

// Get lifestyles
export const getLifestyles = async (
  page = 1,
  perPage = 10,
  sortBy = "id.desc", // Default sorting by id descending
  searchQuery = "",
  brandId = null
) => {
  try {
    const response = await api.get("/v1/admin/lifestyles", {
      params: {
        sortBy, // Sorting by id descending
        page,
        perPage,
        search: searchQuery,
        brandId,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching lifestyles:", error);
    throw error;
  }
};

// Get lifestyle by ID
export const getLifestyleById = async (id) => {
  try {
    const response = await api.get(`/v1/admin/lifestyles/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching lifestyle:", error);
    throw error;
  }
};

// Create lifestyle
export const createLifestyle = async (lifestyleData) => {
  try {
    const response = await api.post("/v1/admin/lifestyles", lifestyleData);
    return response.data;
  } catch (error) {
    console.error("Error creating lifestyle:", error);
    throw error;
  }
};

// Update lifestyle
export const updateLifestyle = async (id, lifestyleData) => {
  try {
    const response = await api.put(`/v1/admin/lifestyles/${id}`, lifestyleData);
    return response.data;
  } catch (error) {
    console.error("Error updating lifestyle:", error);
    throw error;
  }
};

// Delete lifestyle
export const deleteLifestyle = async (id) => {
  try {
    await api.delete(`/v1/admin/lifestyles/${id}`);
    return id;
  } catch (error) {
    console.error("Error deleting lifestyle:", error);
    throw error;
  }
};
